/*
 * Copyright (C) 2024 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import React from 'react';
import {ExdsButtonLink, ExdsImage, ExdsLayout, ExdsLayoutItem} from '@exds/core';
import './Header.css';
import {ExdsIconExternalLink} from '@exds/icons';
import jpmcLogo from '../../assets/images/JPMC_Logo.svg';

const Header = () => {

  return (
    <ExdsLayout
      display="flex"
      alignItems="flex-start"
      justifyContent="space-around"
      flexWrap="nowrap"
      style={{
        marginTop: '32px'
      }}
    >
      <ExdsLayoutItem>
        <ExdsImage
          alt="JPMC logo"
          horizontalPosition="left"
          src={jpmcLogo}
          verticalPosition="center"
        />
      </ExdsLayoutItem>
      <ExdsLayoutItem>
        <ExdsButtonLink
          color="brand"
          href="https://hr.jpmorganchase.com/hr?id=kb_article&sysparm_article=KB0010463"
          target="_blank"
          rel="noopener noreferrer"
          icon={<ExdsIconExternalLink aria-hidden color="regular" size="medium"/>}
          iconPosition="trailing"
          size="regular"
          text="Help"
          variant="secondary"
        />
      </ExdsLayoutItem>
    </ExdsLayout>
  );
};

export default Header;
